import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Product } from '../../../models/product.model';
import { Order } from '../../../models/order.model';

@Component({
  selector: 'products-grid-related',
  templateUrl: './grid-related.component.html',
  styleUrls: ['./grid-related.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductsGridRelatedComponent {
  @Input()
  public products: Product[];

  @Input()
  public order: Order;

  constructor() {}
}
